import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs/Observable';
import { ResponseData } from '../../nest-responses';

/*
  Generated class for the BenefitMarketplaceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BenefitMarketplaceApi {
    private readonly service: string = 'benefit';
    private readonly model: string = 'benefitService';

    constructor(private nestApiProvider: NestApiProvider) {
        console.log('Hello BenefitMarketplaceApi Provider');
    }

    public synchronizeTokenMarketplace(): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'synchronizeTokenMarketplace';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, null, null, false);
    }
    
    public getPersonalData(): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getPersonalData';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, 'marketplace', func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, null, null, false);
    }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/flexible-benefit/benefit-marketplace/benefit-marketplace.api.ts